import Partner                    from '@/domains/Partners/Partner';
import Person                     from '@/domains/Persons/Person';
import Store                      from '@/domains/Stores/Store';
import Company                    from '@/domains/Companies/Company';
import BankAccount                from '@/domains/BankAccounts/BankAccount';
import Contract                   from '@/domains/Contracts/ContractExternal';
import ContractExternal           from '@/domains/Contracts/ContractExternal';
import Demand                     from '@/domains/Demand/Demand';
import DemandV2                   from '@/domains/DemandsV2/DemandV2';
import Tender                     from '@/domains/Tenders/Tender';
import Assembly                   from '@/domains/Assemblies/Assembly';
import PaymentRequest             from '@/domains/PaymentRequests/PaymentRequest';
import Shipment                   from '@/domains/Shipments/Shipment';
import ShipmentPosition           from '@/domains/Shipments/ShipmentPosition';
import Product                    from '@/domains/Products/Product';
import Order                      from '@/domains/Orders/Order';
import OrderPosition              from '@/domains/Orders/OrderPosition';
import AssemblyPosition           from '@/domains/Assemblies/AssemblyPosition';
import TransportOrder             from '@/domains/TransportOrders/TransportOrder';
import PaymentRequestPosition     from '@/domains/PaymentRequests/PaymentRequestPosition';
import Preorder                   from '@/domains/Preorders/Preorder';
import PreorderPosition           from '@/domains/Preorders/PreorderPosition';
import Unit                       from '@/domains/Units/Unit';
import TenderBid                  from '@/domains/TenderBids/TenderBid';
import DemandOption               from '@/domains/DemandsV2/DemandOption';
import SupplyOffer                from '@/domains/SupplyOffers/SupplyOffer';
import FileDescriptor             from '@/core/services/Files/FileDescriptor';
import ParticipationDetailProduct from '@/domains/ParticipationDetailProduct/ParticipationDetailProduct';
import DemandRequest              from '@/domains/DemandsV2/DemandRequest';
import Offer                      from '@/domains/Offers/Offer';
import CharacteristicGroup        from '@/domains/CharacteristicGroups/CharacteristicGroup';
import Characteristic             from '@/domains/Characteristics/Characteristic';
import CharacteristicUnit         from '@/domains/CharacteristicUnits/CharacteristicUnit';
import Vehicle                    from '@/domains/Vehicles/Vehicle';
import Contact                    from '@/domains/Contacts/Contact';
import Package                    from "@/domains/Packages/Package";
import Manufacturer               from "@/domains/Manufacturers/Manufacturer";
import ProductionPlanProduct from "@/domains/ProductionPlans/ProductionPlanProduct";

/**
 * Реестр сущностей по backend type name. Бэк присылает строку ('partner'),
 * по ней находим JS-класс — для парсинга changes через декораторы полей.
 * Через декораторы класса собрать его нельзя: модуль не импортирован →
 * декоратор не выполнится, tree shaking выбросит класс из бандла.
 */
const ENTITY_REGISTRY = new Map<string, any>([
    ['partner',                Partner],
    ['person',                 Person],
    ['store',                  Store],
    ['company',                Company],
    ['bankAccount',            BankAccount],
    ['contract',               Contract],
    ['contractExternal',       ContractExternal],
    ['demand',                 Demand],
    ['demandV2',               DemandV2],
    ['tender',                 Tender],
    ['assembly',               Assembly],
    ['paymentRequest',         PaymentRequest],
    ['shipment',               Shipment],
    ['shipmentPosition',       ShipmentPosition],
    ['product',                Product],
    ['order',                  Order],
    ['orderPosition',          OrderPosition],
    ['assemblyPosition',       AssemblyPosition],
    ['transportOrder',         TransportOrder],
    ['paymentRequestPosition', PaymentRequestPosition],
    ['preorder',               Preorder],
    ['preorderPosition',       PreorderPosition],
    ['unit',                   Unit],
    ['tenderBid',              TenderBid],
    ['demandOption',           DemandOption],
    ['supplyOffer',            SupplyOffer],
    ['FileDescriptor',         FileDescriptor],
    ['tenderParticipation',    ParticipationDetailProduct],
    ['demandRequest',          DemandRequest],
    ['offer',                  Offer],
    ['characteristicGroup',    CharacteristicGroup],
    ['characteristic',         Characteristic],
    ['characteristicUnit',     CharacteristicUnit],
    ['vehicle',                Vehicle],
    ['contact',                Contact],
    ['package',                Package],
    ['manufacturer',           Manufacturer],
    ['productionPlanProduct',  ProductionPlanProduct],
]);
export default ENTITY_REGISTRY;

/**
 * Список опций { id, name } для UI селекторов фильтров.
 * Использует декоратор @Title_ru_RU_Class для получения русского имени.
 */
export function getEntityTypeOptions() {
    return Array.from(ENTITY_REGISTRY.entries())
        .map(([id, cls]) => ({ id, name: cls.entityTypeName }))
        .filter(item => item.name !== undefined)
        .sort((a, b) => a.name!.localeCompare(b.name!));
}